// The `download` attribute on a plain <a> is ignored by browsers for
// cross-origin URLs (only same-origin/blob:/data: URLs honor it), so a link
// straight to a signed DO Spaces URL or the API's own origin just navigates
// instead of saving. Fetching the bytes ourselves and downloading from the
// resulting (same-origin) blob URL works regardless of where the file lives.
export const downloadFile = async (url, fileName) => {
  if (!url) return;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.status}`);
    }
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName || "download";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch {
    // CORS or network failure — fall back to letting the browser handle it.
    window.open(url, "_blank", "noopener,noreferrer");
  }
};
